import type { WebUserRoundEntryUnit } from "@/types/WebUserRoundEntryUnit";
import { useState } from "react";
import { PhoneNumberAuthenticationModal } from "../PhoneNumberAuthenticationModal";
import { LoadingMyEntry } from "./LoadingMyEntry";
import { NoRoundData } from "./NoRoundData";
import { RoundEntryCard } from "./RoundEntryCard";

type ScheduledTabProps = {
  isLoading: boolean;
  userRoundEntryUnits: WebUserRoundEntryUnit[];
};

export const ScheduledTab = ({ isLoading, userRoundEntryUnits }: ScheduledTabProps) => {
  const [open, setOpen] = useState(false);
  if (isLoading) {
    return <LoadingMyEntry />;
  }

  if (!userRoundEntryUnits.length && !isLoading) {
    return <NoRoundData />;
  }

  return (
    <div className="min-h-screen bg-blue w-full">
      <div className="flex justify-center items-center text-primary text-[12px] pt-4 pb-1 md:pt-8 md:pb-4 px-4 text-center">
        <span onClick={() => setOpen(true)} className="md:whitespace-nowrap whitespace-pre-line">
          あなたがエントリー中の大会の一覧です。
          <span className="block md:inline">試合が始まると、獲得中の賞金を確認できます。</span>
        </span>
      </div>

      {userRoundEntryUnits.map((roundEntryUnit) => (
        <RoundEntryCard key={roundEntryUnit.id} roundEntryUnit={roundEntryUnit} shouldShowDecimal={false} />
      ))}

      <PhoneNumberAuthenticationModal open={open} setOpen={setOpen} />
    </div>
  );
};
